import api from './api'
import i18n from 'live/services/i18n'

import { EventEmitter } from 'events'
import _ from 'lodash'

import Dispatcher from 'live/lib/dispatcher'
import Constants from './constants'

const CHANGE_EVENT = 'change'

const Factory = (namespace, actions) => {
    let _qualifier = ''
    let _queries = []
    let _loading = false
    let _loadingQuery = {}
    let _startedQuery = {}
    let _httpDetailedError = ''
    let _httpFailure = ''
    let _failureTitle = ''
    let _controller = null


    const cleanErrors = function () {
        _httpDetailedError = ''
        _httpFailure = ''
        _failureTitle = ''
    }

    const cleanIfQualifierChanged = function (qualifier) {
        if (qualifier !== _qualifier) {
            _qualifier = qualifier
            _queries = []
            _loading = false
            _loadingQuery = {}
            _startedQuery = {}
            cleanErrors()
        }
    }

    const setLoading = function (value) {
        _loading = value
        Store.emitChange()
    }

    const getQueries = function (params) {
        const { qualifier } = params
        cleanErrors()
        setLoading(true)

        api.getQueries(
            qualifier,
            _controller?.signal,
            data => {
                _queries = data.queries
                setLoading(false)
            },
            (failure, data) => {
                _httpFailure = failure
                _httpDetailedError = data
                _failureTitle = i18n('Failure to list MongoDB queries')
                setLoading(false)
            }
        )
    }

    const explainQuery = function (params) {
        const { qualifier, queryInfo, index } = params

        _loadingQuery[index] = true
        _startedQuery[index] = true
        Store.emitChange()

        api.explainQuery(
            qualifier,
            queryInfo,
            _controller?.signal,
            data => {
                _queries[index].explain = data
                _loadingQuery[index] = false
                Store.emitChange()
            },
            (failure, data) => {
                _httpFailure = failure
                _httpDetailedError = data
                _failureTitle = i18n('Failure to probe MongoDB query explainer')

                _loadingQuery[index] = false
                Store.emitChange()
            }
        )
    }

    const Store = _.merge({}, EventEmitter.prototype, {
        state: function () {
            return {
                queries: _queries,
                loadingQueries: _loading,
                loadingQuery: _loadingQuery,
                startedQuery: _startedQuery,
                httpDetailedError: _httpDetailedError,
                httpFailure: _httpFailure,
                commandFailure: _failureTitle
            }
        },
        emitChange: function () {
            this.emit(CHANGE_EVENT)
        },
        addChangeListener: function(callback) {
            _controller = new AbortController()
            this.on(CHANGE_EVENT, callback)
        },
        removeChangeListener: function(callback) {
            _controller.abort()
            this.removeListener(CHANGE_EVENT, callback)
        },
        dispatcher: Dispatcher.register(function (payload) {
            const action = payload.action
            const ns = action.namespace

            if (ns != namespace) {
                return true
            }

            const params = action.params
            cleanIfQualifierChanged(params.qualifier)

            switch (action.actionType) {
                case Constants.GET_QUERIES:
                    getQueries(params)
                    break
                case Constants.EXPLAIN_QUERY:
                    explainQuery(params)
                    break
                default:
                    break
            }

            return true
        })
    })

    return Store
}

export default Factory
